<!-- Filtre -->
<div class="row" id="search-beneficiaries">
  <div class="col-12">
    <h3 class="text-secondary">Recherche par :</h3>
    <div *ngIf="beneficiaryFormGroup?.errors?.invalidFilter" class="alert alert-warning mt-2">
      Le filtre est incorrect (attention si vous utilisez le caractère *, il ne peut être qu'au début ou à la fin).
    </div>
    <form [formGroup]="beneficiaryFormGroup" *ngIf="beneficiaryFormGroup" (ngSubmit)="onSubmit()">
      <div class="row align-items-lg-end">
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label>N° Insertis, N° CAF / MSA, Nom ou Nom de famille</label>
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              formControlName="nameOrCAF"
              ngbTooltip="Commencer et/ou terminer par * pour rechercher des mots incomplets."
            />
            <button type="button" class="input-group-append btn btn-secondary" (click)="advancedFilters = !advancedFilters">
              Recherche avancée
              <fa-icon class="ms-1" icon="caret-up" [flip]="advancedFilters ? null : 'vertical'"> </fa-icon>
            </button>
          </div>
        </div>
        <div class="mb-3 col-12 col-lg-6 col-xl-auto ms-xl-1" *appOnlyGroups="['STRUCTURE', 'TERRITORY']">
          <div
            class="btn-group btn-group-toggle"
            style="min-width: 203.63px"
            ngbTooltip="Cliquer pour rechercher des participants à vos actions collectives uniquement."
            placement="top"
          >
            <input
              class="btn-check"
              (change)="handleSearchModeChanged('participant')"
              type="checkbox"
              formControlName="searchFromCommunity"
              id="searchFromCommunityId"
            />
            <label class="btn btn-light mb-0" for="searchFromCommunityId">Participants uniquement </label>
          </div>
        </div>
        <div class="mb-3 col-12 col-lg-6 col-xl-auto ms-xl-1" *appOnlyGroups="['STRUCTURE']">
          <div
            class="btn-group btn-group-toggle"
            style="min-width: 203.63px"
            ngbTooltip="Cliquer pour rechercher des bénéficiaires que vous avez suivi dans les deux dernières années."
            placement="top"
          >
            <input
              class="btn-check"
              (change)="handleSearchModeChanged('retroactive')"
              type="checkbox"
              formControlName="searchRetroactive"
              id="searchRetroactiveId"
            />
            <label class="btn btn-light mb-0" for="searchRetroactiveId">Recherche rétroactive </label>
          </div>
        </div>
        <div class="d-grid mb-3 d-flex align-items-end col-12 col-lg-6 col-xl-auto ms-xl-1">
          <button
            class="btn btn-primary"
            type="button"
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'RECEPTION']"
            (click)="retrieveLastBeneficiaries()"
          >
            Historique
          </button>
        </div>
        <div class="d-grid mb-3 d-flex align-items-end col-12 col-lg-6 ms-xl-auto col-xl-auto">
          <button
            class="btn btn-primary"
            type="button"
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY']"
            [routerLink]="['/beneficiaries', 'new']"
          >
            Ajouter un bénéficiaire
          </button>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-12">
          <small *ngIf="beneficiaryFormGroup.controls?.nameOrCAF?.invalid" class="form-text text-danger"
            >N° CAF / MSA, Nom ou Nom de famille invalide.</small
          >
        </div>
      </div>
      <div class="row" *ngIf="advancedFilters">
        <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-2">
          <label>Prénom</label>
          <input class="form-control" type="text" formControlName="firstName" ngbTooltip="Terminer par * pour rechercher des mots incomplets." />
          <small *ngIf="beneficiaryFormGroup.controls?.firstName?.invalid" class="form-text text-danger">La prénom est invalide.</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-2">
          <label>Date de naissance</label>
          <app-datepicker formControlName="birthDate" [invalid]="beneficiaryFormGroup.controls?.birthDate?.invalid"></app-datepicker>
          <small *ngIf="beneficiaryFormGroup.controls?.birthDate?.invalid" class="form-text text-danger">La date de naissance est invalide.</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-2" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']">
          <label>Type d'accompagnement</label>
          <ng-select id="supportType" [items]="supportTypes" bindValue="id" formControlName="supportType"> </ng-select>
        </div>
        <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-2" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']">
          <label>Statut du dossier</label>
          <select class="form-select" formControlName="status">
            <option [ngValue]=""></option>
            <option *ngFor="let status of folderStatus | keyvalue: stringAscOrder" [ngValue]="status.key">
              {{ status.value }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-2" *appOnlyGroups="['ADMIN', 'DIRECTION', 'DIRECTION+', 'TERRITORY']">
          <label>Structure</label>
          <ng-select id="structure" [items]="structures" bindValue="id" formControlName="structure"> </ng-select>
        </div>
        <ng-container *appOnlyGroups="['STRUCTURE']">
          <div
            class="mb-3 text-secondary col-12 col-lg-6 col-xl-2"
            *ngIf="!(beneficiaryFormGroup.controls.searchFromCommunity.value || beneficiaryFormGroup.controls.searchRetroactive.value)"
          >
            <label>Référent</label>
            <select class="form-select" formControlName="referent">
              <option [ngValue]=""></option>
              <option *ngFor="let referent of userList" [ngValue]="referent.id">
                {{ referent.name }}
              </option>
            </select>
          </div>
        </ng-container>
      </div>
      <div class="row">
        <div class="d-grid col-12 col-sm-12 col-xl-auto">
          <button type="submit" class="btn btn-primary">Rechercher</button>
        </div>
        <div class="d-grid col-12 col-sm-12 col-xl-auto ms-xl-1 mt-sm-2 mt-xl-0">
          <button type="button" class="btn btn-light" (click)="reinitFilters()">Réinitialiser les filtres</button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Tableau de recherche par filtre -->
<ng-template [ngIf]="searchPerformed" [ngIfElse]="init">
  <div class="row mt-1">
    <p class="ms-3 pt-2 text-secondary" *ngIf="beneficiaries.items.length === 0">La recherche ne renvoie aucun résultat.</p>
    <div class="col px-0 pt-2" *ngIf="beneficiaries.items.length !== 0">
      <p class="ms-3 pt-2 text-secondary" *ngIf="!isHistoMode" id="beneficiariesResultTitle">Résultat de la recherche :</p>
      <p class="ms-3 pt-2 text-secondary" *ngIf="isHistoMode" id="beneficiariesResultTitle">Les dix derniers dossiers consultés :</p>
      <div class="table-responsive">
        <table class="table table-striped table-hover" aria-describedby="beneficiariesResultTitle">
          <thead class="text-secondary bg-light">
            <tr>
              <th></th>
              <th scope="col" class="text-center" sortable="insertisId" (sort)="onSort($event)">N° Insertis</th>
              <th scope="col" sortable="usualName" (sort)="onSort($event)">Nom</th>
              <th scope="col" sortable="surname" (sort)="onSort($event)">Nom de famille</th>
              <th scope="col" sortable="firstName" (sort)="onSort($event)">Prénom</th>
              <th scope="col" class="text-center" sortable="birthDate" (sort)="onSort($event)">Date de naissance</th>
              <th scope="col" class="text-center" sortable="status" (sort)="onSort($event)">Statut du dossier</th>
              <th scope="col" class="text-center" sortable="supportType.label" (sort)="onSort($event)">Type d'accompagnement</th>
              <th scope="col" class="text-center" sortable="support.beginDate" (sort)="onSort($event)">Début d'accompagnement</th>
              <th scope="col" class="text-center" sortable="support.endDate" (sort)="onSort($event)">Fin d'accompagnement</th>
              <th scope="col" sortable="structure.label" (sort)="onSort($event)">Structure</th>
              <th scope="col" class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let beneficiary of beneficiaries.items">
              <td></td>
              <td (click)="navigateToBeneficiary(beneficiary, ['details'])" class="text-center">
                {{ beneficiary.insertisId }}
              </td>
              <td (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.usualName }}
              </td>
              <td (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.surname }}
              </td>
              <td (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.firstName }}
              </td>
              <td class="text-center" (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.birthDate | date }}
              </td>
              <td class="text-center" (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ folderStatus.get(beneficiary.status) }}
              </td>
              <td class="text-center" (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.supportTypeLabel }}
              </td>
              <td class="text-center" (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.beginDateSupport | date }}
              </td>
              <td class="text-center" (click)="navigateToBeneficiary(beneficiary, ['details'])">
                {{ beneficiary.endDateSupport | date }}
              </td>
              <td
                (click)="navigateToBeneficiary(beneficiary, ['details'])"
                [ngbTooltip]="beneficiary.structureLabel"
                placement="left"
                container="body"
              >
                {{ beneficiary.structureLabel }}
              </td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary btn-sm"
                  (click)="navigateToBeneficiary(beneficiary, ['folder', 'interviews'])"
                  ngbTooltip="Entretiens"
                  placement="left"
                >
                  <fa-icon class="d-block" icon="user-friends"></fa-icon>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary btn-sm ms-2"
                  (click)="deleteBeneficiary(beneficiary.id)"
                  *appOnlyGroups="['ADMIN']"
                  ngbTooltip="Supprimer"
                  placement="left"
                >
                  <fa-icon class="d-block" icon="trash"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between" *ngIf="beneficiaries.items.length !== 0 && !isHistoMode">
    <ngb-pagination
      [collectionSize]="beneficiaries.totalItems"
      [page]="beneficiaries.options.page"
      [pageSize]="beneficiaries.options.limit"
      [maxSize]="5"
      [rotate]="true"
      [boundaryLinks]="true"
      (pageChange)="changePage($event)"
    >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="beneficiaries.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</ng-template>
<ng-template #init>
  <div class="row mt-1"></div>
</ng-template>
